import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addIndexLine, setAddListName } from '../../../../../Actions/ComparisonAndRotationMenuActions';
import { CompareMenuType } from "CompareTabType";
import { PrintMode } from "../../../../../print/printmode";
import { HoverMenu } from '../Presentational';

import LocalizationStore from "LocalizationStore";

class CompCreateIndexLine extends Component {
    handleCreateIndexLine = (indexLineType) => {
        const { addIndexLine, setAddListName, isCreateIndexLineEnable } = this.props;
        if (isCreateIndexLineEnable){
            setAddListName();
            addIndexLine(indexLineType);
        }
            
    }

    render() {
        return (
            <div className="compare-foot-box">
                {!PrintMode.printing && <HoverMenu 
                   items={[{ 
                        id: 'PriceWeightIndex', 
                        label: LocalizationStore.getTranslatedData("CCG_CreateIndexLine_Info", "Price Weighted"),
                        name: LocalizationStore.getTranslatedData("CCG_PriWeiInd", "Price Weighted Index")
                    },
                    { 
                        id: 'EqualWeightIndex', 
                        label: 'Equal Weighted',
                        name: 'Equal Weighted Index'
                     }
                   ]} 
                   title={LocalizationStore.getTranslatedData("CCG_CreateIndexLine", "Create Index Line")} 
                   isDisabled={!this.props.isCreateIndexLineEnable}
                   onSelect={this.handleCreateIndexLine} />}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { selectedMenuTab, SymbolsData, GroupsData } = state.comparisonGraph.compareChartViewModel;
    const compareChartViewModel = selectedMenuTab == CompareMenuType.Symbols ? SymbolsData : GroupsData;
    const isCreateIndexLineEnable = compareChartViewModel.symbolRequest.length >= 2;

    return ({ isCreateIndexLineEnable });
}

const mapDispatchToProps = (dispatch) => ({
    addIndexLine: (indexLineType) => dispatch(addIndexLine(indexLineType)),
    setAddListName: () =>dispatch(setAddListName())
});

export default connect(mapStateToProps, mapDispatchToProps)(CompCreateIndexLine);